import config from "@/configs/api";
import { createAPI } from "@repo/modules/axios";
import type { API } from "@repo/modules/axios";

const api: API = createAPI({
  origin: import.meta.env.VITE_API_ORIGIN,
  config,
});

export default api;

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $api: API;
  }
}

declare module "pinia" {
  export interface PiniaCustomProperties {
    $api: API;
  }
}
